import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const GenderChart = ({chartData}) => {

  const maleCount = chartData?.find(item => item.gender?.toLowerCase() === 'male')?.total || 0;
  const femaleCount = chartData?.find(item => item.gender?.toLowerCase() === 'female')?.total || 0;

  const data = {
    labels: ['Male', 'Female'],
    datasets: [
      {
        data: [maleCount, femaleCount], // Change this to your actual data percentages
        backgroundColor: ['#2d49fa', '#f09c51'], // Colors for male and female sections
        hoverBackgroundColor: ['#2d49fa', '#f09c51'],
        borderWidth: 0, // Removes border between sections
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%', // Adjusts the width of the donut ring
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          color: '#6b6b6b', // Color of the legend text
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div className="col-xl-4 col-lg-6 order-lg-1">
        <div className="card" style={{ height: '350px' }}>
            <div className="card-body pb-0">
                <div className="mb-3">
                    <div>
                        <h3 className="header-title mb-3">Customers By Gender</h3>
                        <div style={{width: '250px', height: '250px', margin: 'auto'}}>
                            <Doughnut data={data} options={options} />  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default GenderChart;
